import { MainLayout } from "./layouts";
import LandingPage from "./pages/landing";
import ProfilePage from "./pages/profile";

const routes = [
  {
    path: "/",
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: <LandingPage />,
      },
      {
        path: "/profile",
        element: <ProfilePage />,
      },
    ],
  },
];

export default routes;
